var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monitor-details" },
    [
      _c("pui-breadcrumb", {
        attrs: { links: _vm.links },
        on: { "changed:active-route": _vm.onActiveRouteChanged },
      }),
      _c("div", { staticClass: "monitor-details__timeframe-wrapper" }, [
        _c(
          "div",
          { staticClass: "monitor-details__timeframe-wrapper__title" },
          [
            _c("pui-headline", { attrs: { type: "h6" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isCurrentOverviewValueType
                      ? _vm.$t("latestImportedValues")
                      : _vm.$t("selectedTimeframe")
                  ) +
                  " "
              ),
            ]),
          ],
          1
        ),
        !_vm.isCurrentOverviewValueType
          ? _c(
              "div",
              { staticClass: "monitor-details__timeframe-wrapper__content" },
              [_vm._v(" " + _vm._s(_vm.selectedTimeframe) + " ")]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "monitor-details__table-wrapper" }, [
        _c(
          "div",
          { staticClass: "monitor-details__filter-row" },
          [
            _c("pui-tooltip"),
            _vm.isValidationProcess
              ? _c("pui-filter", {
                  attrs: {
                    "use-router": false,
                    config: _vm.getFilter(),
                    "vuex-namespace": "qmdi-monitor-details",
                  },
                  on: { "changed:applied-values": _vm.filterChanged },
                })
              : _vm._e(),
            _vm.isAllowedToEditContent
              ? _c(
                  "pui-button",
                  {
                    staticClass: "monitor-details__filter-row__mark-as-read",
                    attrs: { disabled: this.isMarkAsReadButtonDisabled },
                    on: { click: _vm.markAllAsRead },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("markAsRead")) + " ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "monitor-details__table" },
          [
            _c("pui-table", {
              ref: _vm.DETAILS_TABLE_REF,
              attrs: {
                "vendor-options": _vm.vendorOptions,
                "with-server": "",
                "with-pagination": "",
                "with-limit": "",
                "with-search": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "message",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        { staticClass: "monitor-details__message" },
                        [
                          data.row.data.message
                            ? [
                                _c(
                                  "tooltip",
                                  { attrs: { message: data.row.data.message } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(data.row.data.message) + " "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("notApplicableShort")) +
                                    " "
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "status",
                  fn: function (data) {
                    return [
                      _c("legend-item", {
                        attrs: {
                          "status-color": _vm.getLegendDetails(data.row.status)
                            .color,
                          "label-color": _vm.PUICOLOR_DARK_GREY,
                          label: _vm.getLegendDetails(data.row.status).label,
                          "label-font-size": "1.4rem",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "readStatus",
                  fn: function (data) {
                    return [
                      data.row.data.markAsRead
                        ? _c(
                            "div",
                            {
                              staticClass: "monitor-details__read-status-cell",
                            },
                            [
                              _c("pui-icon", {
                                attrs: {
                                  "icon-color": _vm.PUICOLOR_CONTEXTUAL_GREEN,
                                  "icon-name": "check",
                                },
                              }),
                              _vm._v(" " + _vm._s(_vm.$t("read")) + " "),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "monitor-details__read-status-cell",
                            },
                            [
                              _c("pui-icon", {
                                attrs: {
                                  "icon-color": _vm.PUICOLOR_DARK_GREY,
                                  "icon-name": "close",
                                },
                              }),
                              _vm._v(" " + _vm._s(_vm.$t("unread")) + " "),
                            ],
                            1
                          ),
                    ]
                  },
                },
                {
                  key: "versionTime",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFormattedVersionTime(data.row.versionTime)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "comments",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "monitor-details__comment-cell",
                          on: {
                            click: function ($event) {
                              return _vm.openCommentModal(data.row)
                            },
                          },
                        },
                        [
                          _vm.isAllowedToEditContent
                            ? _c("pui-link", {
                                attrs: {
                                  title: _vm.$t("addComments"),
                                  icon: "icon-add",
                                },
                              })
                            : _c("pui-link", {
                                class: {
                                  "monitor-details__comment-link--disabled":
                                    !data.row.comment,
                                },
                                attrs: {
                                  title: _vm.$t("viewComments"),
                                  icon: "icon-visible",
                                },
                              }),
                          data.row.comment
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "monitor-details__comment-indicator",
                                },
                                [_vm._v(" 1 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("comments-lightbox", {
        attrs: {
          "comment-details": _vm.selectedCommentRow,
          "lightbox-open": _vm.isCommentLightboxOpen,
        },
        on: {
          "close-lightbox": function (refresh) {
            return _vm.handleCloseCommentLightbox(refresh)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }